var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6248 2.45029L21.7521 1.57764L13.6686 9.66114C12.6582 10.6716 10.9588 10.6716 9.94835 9.66114L1.86484 1.62357L0.992188 2.49622L7.00889 8.51292L0.992188 14.5296L1.86484 15.4023L7.88154 9.38557L9.0757 10.5797C9.81056 11.3146 10.7751 11.7279 11.7855 11.7279C12.7959 11.7279 13.7605 11.3146 14.4953 10.5797L15.6895 9.38557L21.7062 15.4023L22.5788 14.5296L16.5621 8.51292L22.6248 2.45029Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9255 16.9638H2.78351C1.72714 16.9638 0.854492 16.0912 0.854492 15.0348V2.08283C0.854492 1.02646 1.72714 0.153809 2.78351 0.153809H20.9255C21.9818 0.153809 22.8545 1.02646 22.8545 2.08283V15.0348C22.8545 16.0912 21.9818 16.9638 20.9255 16.9638ZM2.73758 1.39389C2.37015 1.39389 2.09458 1.66947 2.09458 2.0369V14.9889C2.09458 15.3563 2.37015 15.6319 2.73758 15.6319H20.8795C21.247 15.6319 21.5226 15.3563 21.5226 14.9889V2.0369C21.5226 1.66947 21.247 1.39389 20.8795 1.39389H2.73758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTemplate);
export default __webpack_public_path__ + "static/media/emailTemplate.bd7ce54ce41b261550098e0a7ec57663.svg";
export { ForwardRef as ReactComponent };